import { DSNCExpandableImage, DSNCImage, DSNCLinkedImage } from 'shared-definitions/types'
import { ApiComponentImage } from 'data-source/types.wp'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { pLinkMapper, PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

type Res<T> = T | T[]

export function ncImage(
  input: ApiComponentImage,
  opts: PLinkMapperOpts
): Res<DSNCExpandableImage | DSNCLinkedImage | DSNCImage> {
  const image = imageMapper(input, opts)
  if (!image) {
    return []
  }

  if (input.expandable) {
    return {
      resource: 'nc-expandable-img',
      image,
      badges: [],
    }
  }
  if (input.url) {
    return {
      resource: 'nc-linked-img',
      image,
      pLink: pLinkMapper(input.url, opts),
      badges: [],
    }
  }
  return {
    badges: [],
    resource: 'nc-img',
    image,
  }
}
